import {createAction} from "redux-act";

export interface IRewardStatsResponse {
	rewards: IRewardStat[];
}

export interface IRewardStat {
	reward: string;
	earnedPercentage: number;
	rarity: string;
	color: string;
}

export const fetchRewardStats = createAction();
export const fetchRewardStatsSuccess = createAction<IRewardStatsResponse>();
export const fetchRewardStatsErrors = createAction();
